import * as React from 'react';
import { useHistory } from "react-router-dom";
import { Button } from 'primereact/button';
import { Alert } from 'reactstrap';
import { useParams } from "react-router-dom";
import { deleteData } from "../../../components/bot/storage"
import moment from 'moment';

export default function StartStep(props) {

    const [saving, setSaving] = React.useState(false)
    const positionComplete = props.steps[props.endPosition] ? true : false;
    const quadroComplete = props.steps[props.endQuadro] ? true : false;
    const canComplete = props.steps[props.endCan] || props.noCanTest ? true : false;
    const bloccoComplete = props.steps[props.endBlocco] ? true : false;
    const finalComplete = props.steps[props.finalBlock] ? true : false;
    const collaudoCompleted = (positionComplete && quadroComplete && bloccoComplete && canComplete) || finalComplete;

    function getType(completed) {
        return completed ? 'success' : 'secondary';
    }

    return (
        <div>
            {!collaudoCompleted && (
                <div>
                    <div>
                        {`Test da effettuare per il collaudo del veicolo:`}
                    </div>
                    
                    <Button
                        className={`p-button-${getType(positionComplete)} p-button-rounded`}
                        label={'TEST POSIZIONE'}
                        icon="fas fa-crosshairs"
                        disabled={positionComplete}
                        onClick={() => props.triggerNextStep({ trigger: props.triggerPosition })}
                        style={{ marginRight: '5px', marginTop: '5px' }}
                    />
                    <Button
                        className={`p-button-${getType(quadroComplete)} p-button-rounded`}
                        disabled={quadroComplete}
                        label={'TEST QUADRO'}
                        icon="fas fa-desktop"
                        onClick={() => props.triggerNextStep({ trigger: props.triggerQuadro })}
                        style={{ marginRight: '5px', marginTop: '5px' }}
                    />
                    <Button
                        className={`p-button-${getType(canComplete)} p-button-rounded`}
                        disabled={canComplete}
                        label={'TEST LINEA CAN'}
                        icon="fas fa-network-wired"
                        onClick={() => {props.triggerNextStep({ trigger: props.triggerCan })}}
                        style={{ marginRight: '5px', marginTop: '5px' }}
                    />
                    <Button
                        className={`p-button-${getType(bloccoComplete)} p-button-rounded`}
                        disabled={bloccoComplete}
                        label={'TEST BLOCCO AVVIAMENTO'}
                        icon="fas fa-stop-circle"
                        onClick={() => props.triggerNextStep({ trigger: props.triggerBlocco })}
                        style={{ marginRight: '5px', marginTop: '5px' }}
                    />
                </div>
            )}
            {collaudoCompleted && (
                <Alert
                    color="green"
                    title={'COLLAUDO COMPLETATO CORRETTAMENTE'}>
                    <div>
                        <Button
                            disabled={saving ? true : false}
                            className={`p-button-success p-button-rounded`}
                            label={'REGISTRA COLLAUDO e CREA PDF'}
                            icon={saving ? "pi pi-spin pi-spinner" : "fas fa-flag-checkered"}
                            onClick={async () => {
                                try {
                                    setSaving(true)
                                    const steps = [
                                        /* props.steps['test-blocco-1-verify'],
                                        props.steps['test-sblocco-1-verify'],
                                        props.steps['test-quadro-off'] */
                                        props.steps['test-posizione'],
                                        props.steps['test-quadro-on'],
                                        props.steps['test-blocco-1']
                                    ]

                                    const collaudo = await props.onSaveCollaudo(steps);
                                    props.triggerNextStep({ trigger: props.finalBlock, value: { collaudo, isTestFinished: true, timestamp: moment().toJSON() } })
                                } finally {
                                    setSaving(false)
                                }

                            }}
                        />
                    </div>
                </Alert>
            )}
        </div>
    );
}

function BackToStart({ backTrigger, cacheKey, triggerNextStep }) {
    const { collaudoId } = useParams();

    const { push } = useHistory();

    const onClick = () => {
        push(`/`);
        push(`/collaudo/test-dashboard/${collaudoId}`);
      };
    
    return (
        <div>
            <Button
                className="p-button-warning p-button-rounded mr-2"
                label={'ABBANDONA TEST'}
                icon="pi pi-power-off"
                onClick={() => {
                    const answ = confirm('Abbandonando il test i dati relativi al test in corso verranno persi. Sicuro di voler proseguire?');
                    if (answ) {
                        triggerNextStep({ trigger: backTrigger, value: { aborted: true, timestamp: moment().toJSON() } });
                    }
                }}
            />

            <Button
                className="p-button-primary p-button-rounded"
                label={'RICOMINCIA COLLAUDO'}
                icon="pi pi-undo"
                onClick={async () => {
                    if (confirm('Tutti i dati relativi ai test eseguiti sul collaudo verranno persi. Sicuro di voler proseguire?')) {
                        await deleteData(collaudoId);
                        onClick();
                    }
                }}
            />
        </div>
    );
}

export function withReset(
    WrappedComponent,
    backTrigger,
    abortedMessage
) {
    return class extends React.Component {
        render() {
            const aborted = this.props.step.value && this.props.step.value.aborted;
            const completed = this.props.step.value && this.props.step.value.completed;
            const skipped = this.props.step.value && this.props.step.value.skipped;
            const error = this.props.step.value && this.props.step.value.error;
            return (
                <div>
                    {aborted && (
                        <div className="text-center">
                            <i className="fas fa-ban text-5xl" />
                            <div>{abortedMessage} ANNULLATO DA UTENTE</div>
                        </div>
                    )}
                    {skipped && (
                        <div className="text-center">
                            <i className="fas fa-ban text-5xl" />
                            <div>{abortedMessage} FORZATO DA ADMIN</div>
                        </div>
                    )}
                    {!aborted && !skipped && <WrappedComponent {...this.props} />}
                    {!aborted && !completed && !error && (
                        <div className="mt-4">
                            <BackToStart
                                backTrigger={backTrigger}
                                triggerNextStep={this.props.triggerNextStep}
                            />
                        </div>
                    )}
                </div>
            );
        }
    };
}
